// extracted by mini-css-extract-plugin
export default {"wrapperClass":"QxR5s5L4UUkKJR2t07Ex"};